export default "__VITE_PUBLIC_ASSET__1f4c87fe__"